export default "__VITE_ASSET__Dp48gakI__"